import { useState } from "react";
import { MapPin, ChevronDown, Check, LocateFixed } from "lucide-react";
import { useLocate } from "@/lib/geo";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useApp } from "@/context/AppContext";
import { AnkaraStrip } from "./ui";

const ACCENTS = { montreal: "#1E4D3B", gta: "#C2410C", "ottawa-gatineau": "#B45309", calgary: "#7C2D12", edmonton: "#166534", "quebec-city": "#133E2F" };

export const CityPill = ({ onDark }) => {
  const { hub, L } = useApp();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button data-testid="city-selector" onClick={() => setOpen(true)}
        className={`press inline-flex items-center gap-2 min-h-[48px] px-4 rounded-full font-bold ${onDark ? "bg-[#FFFDF9] text-[#1E4D3B]" : "bg-[#1E4D3B] text-white"} shadow-md`}>
        <MapPin className="w-4 h-4 text-[#D97706]" aria-hidden="true" /> {L(hub)} <ChevronDown className="w-4 h-4" aria-hidden="true" />
      </button>
      <CityPicker open={open} onOpenChange={setOpen} />
    </>
  );
};

export const CityPicker = ({ open, onOpenChange }) => {
  const { meta, hub, L, t, selectHub } = useApp();
  const { locate, busy } = useLocate();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="rounded-t-[28px] bg-[#FAF7F2] max-h-[88vh] overflow-y-auto p-0" data-testid="city-picker">
        <AnkaraStrip className="rounded-t-[28px]" />
        <div className="p-5">
          <SheetHeader><SheetTitle className="text-2xl font-extrabold text-left">{t("choose_city")}</SheetTitle></SheetHeader>
          <button data-testid="city-use-location" disabled={busy} onClick={async () => { if (await locate()) onOpenChange(false); }}
            className="press mt-4 w-full min-h-[52px] rounded-2xl bg-[#1E4D3B] text-white font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60">
            <LocateFixed className="w-5 h-5 text-[#F59E0B]" />{t("loc_use")}
          </button>
          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            {meta.hubs.map((h) => {
              const soon = h.launch_status !== "active";
              return (
                <button key={h.id} data-testid={`city-option-${h.id}`} onClick={() => { selectHub(h.id); onOpenChange(false); }}
                  className={`press flex items-center gap-4 p-3 rounded-2xl bg-[#FFFDF9] border-2 text-left ${hub?.id === h.id ? "border-[#1E4D3B]" : "border-[#E8E2D9]"}`}>
                  <div className="w-14 h-14 rounded-xl relative overflow-hidden shrink-0" style={{ background: ACCENTS[h.id] }}>
                    <div className="absolute inset-0 ankara-dots opacity-60" />
                    <span className="absolute inset-0 flex items-center justify-center text-[#FDE68A] font-extrabold text-lg">{L(h).slice(0, 2).toUpperCase()}</span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-bold text-lg">{L(h)}</div>
                    <span className={`inline-flex mt-1 rounded-full px-2.5 py-0.5 text-xs font-bold ${soon ? "bg-[#FEF3C7] text-[#78350F]" : "bg-[#DCFCE7] text-[#14532D]"}`}>
                      {soon ? t("soon") : t("active_hub")}
                    </span>
                  </div>
                  {hub?.id === h.id && <Check className="w-5 h-5 text-[#1E4D3B]" aria-hidden="true" />}
                </button>
              );
            })}
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
